import { render } from "./list-blacklist.vue?vue&type=template&id=e9b11700&lang=html"
import script from "./list-blacklist.vue?vue&type=script&lang=js"
export * from "./list-blacklist.vue?vue&type=script&lang=js"

import "./list-blacklist.vue?vue&type=style&index=0&id=e9b11700&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__